import { Link } from 'react-router-dom';

export default function ArticleCards() {
  return (
    <section className="bg-background-50 py-20 md:py-24 px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-left mb-14">
          <h2 className="text-4xl md:text-[64px] font-heading font-bold text-foreground-950 leading-none">
            SEO Гайды
          </h2>
          <p className="text-4xl md:text-[64px] font-heading italic text-foreground-600 leading-none mt-1">
            YOYBUY
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link
            to="/article/yoybuy-spreadsheet-guide"
            className="group flex flex-col rounded-2xl bg-white border border-foreground-100/60 overflow-hidden hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
          >
            <div className="relative h-[240px] bg-accent-50 flex items-center justify-center overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20spreadsheet%20and%20shopping%20concept%20illustration%20with%20pastel%20mint%20background%2C%20organized%20fashion%20items%20grid%20layout%2C%20clean%20modern%20data%20organization%20visual%2C%20soft%20and%20airy%20design%20for%20blog%20thumbnail%2C%20editorial%20minimal%20style%20with%20gentle%20color%20palette&width=600&height=400&seq=article-card-01&orientation=landscape"
                alt="YOYBUY Spreadsheet полное руководство"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <h3 className="text-xl font-heading font-semibold text-foreground-900 leading-snug group-hover:text-accent-700 transition-colors">
                YOYBUY Spreadsheet: Полное руководство 2026
              </h3>
              <p className="mt-2 text-sm text-foreground-400 font-light leading-relaxed">
                Узнайте всё о YOYBUY Spreadsheet: как работает, преимущества, сравнение с Kakobuy и Superbuy, пошаговая инструкция для начинающих.
              </p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm text-accent-600 font-medium group-hover:text-accent-700 transition-colors">
                Читать статью
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          <div className="flex flex-col rounded-2xl bg-white border border-foreground-100/60 overflow-hidden opacity-60">
            <div className="relative h-[240px] bg-secondary-50 flex items-center justify-center overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Comparison%20chart%20concept%20illustration%20with%20soft%20pink%20background%2C%20side%20by%20side%20platform%20comparison%20visual%2C%20modern%20editorial%20infographic%20style%2C%20clean%20minimal%20design%20for%20blog%20thumbnail%2C%20pastel%20color%20palette%20with%20gentle%20contrast&width=600&height=400&seq=article-card-02&orientation=landscape"
                alt="Сравнение агентов шоппинга"
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-4 right-4 px-3 py-1 rounded-full bg-white/80 text-foreground-500 text-xs font-medium">
                Скоро
              </span>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-heading font-semibold text-foreground-500 leading-snug">
                YOYBUY vs Kakobuy vs Superbuy: Сравнение
              </h3>
              <p className="mt-2 text-sm text-foreground-400 font-light leading-relaxed">
                Детальное сравнение трёх крупнейших spreadsheet-агентов для шоппинга из Китая. Цены, скорость, надёжность.
              </p>
            </div>
          </div>

          <div className="flex flex-col rounded-2xl bg-white border border-foreground-100/60 overflow-hidden opacity-60">
            <div className="relative h-[240px] bg-primary-50 flex items-center justify-center overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Step%20by%20step%20guide%20concept%20illustration%20with%20warm%20peach%20background%2C%20shopping%20process%20flow%20diagram%20visual%2C%20clean%20tutorial%20style%20design%20for%20blog%20thumbnail%2C%20minimal%20editorial%20layout%20with%20soft%20warm%20lighting&width=600&height=400&seq=article-card-03&orientation=landscape"
                alt="Как заказывать из Китая"
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute top-4 right-4 px-3 py-1 rounded-full bg-white/80 text-foreground-500 text-xs font-medium">
                Скоро
              </span>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-heading font-semibold text-foreground-500 leading-snug">
                Как заказывать из Китая через Spreadsheet
              </h3>
              <p className="mt-2 text-sm text-foreground-400 font-light leading-relaxed">
                Пошаговая инструкция для новичков: от выбора товара на Taobao до получения посылки в России.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}